(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["confidis-events"] && !Shopify.designMode) return;
  try {
    
  const bindRsvp = (root) => {
    root.querySelectorAll('[data-confidis-rsvp]').forEach((form) => {
      if (form.dataset.confidisBound === 'true') return;
      form.dataset.confidisBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const panel = form.closest('.confidis-events__rsvp') || form.parentElement;
        const status = panel?.querySelector('[data-confidis-status]');
        const zoomWrap = panel?.querySelector('[data-confidis-zoom]');
        const zoomLink = panel?.querySelector('[data-confidis-zoom-link]');
        const button = form.querySelector('button[type="submit"]');
        if (status) status.textContent = 'Submitting…';
        if (button) button.disabled = true;
        try {
          const payload = Object.fromEntries(new FormData(form).entries());
          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (status) {
            status.textContent = data.ok
              ? data.message || 'Registered.'
              : data.error || 'Something went wrong.';
          }
          if (data.ok) {
            form.hidden = true;
            if (data.zoom_link && zoomWrap && zoomLink) {
              zoomLink.href = data.zoom_link;
              zoomLink.textContent = data.zoom_link;
              zoomWrap.hidden = false;
            }
          }
        } catch (error) {
          if (status) status.textContent = 'Could not submit. Try again in a moment.';
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  };
  bindRsvp(document);

  const list = document.querySelector('[data-confidis-event-list]');
  const grid = document.querySelector('[data-confidis-event-grid]');
  const calendar = document.querySelector('[data-confidis-calendar]');
  const viewButtons = document.querySelectorAll('[data-confidis-view]');
  const lightbox = document.querySelector('[data-confidis-event-lightbox]');
  const lightboxBody = document.querySelector('[data-confidis-lightbox-body]');

  const toLocalInput = (value) => {
    if (!value) return '';
    return String(value).replace(' ', 'T').slice(0, 16);
  };

  const openLightbox = (handle) => {
    if (!lightbox || !lightboxBody || !handle) return;
    const source = document.querySelector(`[data-confidis-event-source="${handle}"]`);
    if (!source) return;
    lightboxBody.innerHTML = source.innerHTML;
    bindRsvp(lightboxBody);
    if (!lightbox.open) lightbox.showModal();
    if (window.location.hash !== `#${handle}`) {
      history.replaceState(null, '', `#${handle}`);
    }
  };

  document.querySelectorAll('[data-confidis-open-event]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openLightbox(button.getAttribute('data-handle') || '');
    });
  });
  document.querySelector('[data-confidis-lightbox-close]')?.addEventListener('click', () => {
    lightbox?.close();
    history.replaceState(null, '', window.location.pathname);
  });
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) {
      lightbox.close();
      history.replaceState(null, '', window.location.pathname);
    }
  });
  if (window.location.hash) {
    openLightbox(window.location.hash.replace(/^#/, ''));
  }

  if (list && viewButtons.length) {
    const datedItems = [...list.querySelectorAll('.confidis-events__item')];
    datedItems.sort((left, right) => {
      const leftDate = left.getAttribute('data-date') || '';
      const rightDate = right.getAttribute('data-date') || '';
      if (!leftDate && !rightDate) return 0;
      if (!leftDate) return 1;
      if (!rightDate) return -1;
      return rightDate.localeCompare(leftDate);
    });
    datedItems.forEach((item) => list.appendChild(item));

    const events = [...list.querySelectorAll('[data-date]')].map((item) => ({
      date: item.getAttribute('data-date'),
      title: item.getAttribute('data-title'),
      time: item.getAttribute('data-time'),
      endTime: item.getAttribute('data-end-time'),
      handle: item.getAttribute('data-handle'),
    }));
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const today = new Date();
    const view = new Date(today.getFullYear(), today.getMonth(), 1);
    const eventYears = events
      .map((event) => (event.date || '').slice(0, 4))
      .filter(Boolean)
      .map(Number);
    const minYear = Math.min(today.getFullYear() - 1, ...eventYears, today.getFullYear());
    const maxYear = Math.max(today.getFullYear() + 2, ...eventYears, today.getFullYear());
    let selectedDay = '';
    let appliedLayout = '';
    const compactWidth = 990;
    const weekdayShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const isCompactCalendar = () => {
      const width = calendar?.getBoundingClientRect().width || 0;
      if (width > 0) return width < compactWidth;
      return window.matchMedia(`(max-width: ${compactWidth - 1}px)`).matches;
    };

    const eventTimeLabel = (event) => {
      if (!event.time) return '';
      if (event.endTime && event.endTime !== event.time) return `${event.time} – ${event.endTime}`;
      return event.time;
    };

    const defaultSelectedDay = () => {
      const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
        today.getDate(),
      ).padStart(2, '0')}`;
      if (events.some((event) => event.date === todayIso)) return todayIso;
      const year = view.getFullYear();
      const month = String(view.getMonth() + 1).padStart(2, '0');
      const prefix = `${year}-${month}-`;
      const upcoming = events
        .map((event) => event.date)
        .filter((date) => date && date.startsWith(prefix) && date >= todayIso)
        .sort();
      if (upcoming[0]) return upcoming[0];
      const inMonth = events
        .map((event) => event.date)
        .filter((date) => date && date.startsWith(prefix))
        .sort();
      return inMonth[0] || todayIso;
    };

    const renderCalendar = () => {
      if (!calendar) return;
      const compact = isCompactCalendar();
      appliedLayout = compact ? 'compact' : 'wide';
      calendar.setAttribute('data-layout', appliedLayout);
      if (!selectedDay) selectedDay = defaultSelectedDay();
      const year = view.getFullYear();
      const month = view.getMonth();
      const yearStart = Math.min(minYear, year);
      const yearEnd = Math.max(maxYear, year);
      const start = new Date(year, month, 1);
      const startPad = start.getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
        today.getDate(),
      ).padStart(2, '0')}`;
      let monthOptions = '';
      monthNames.forEach((name, index) => {
        monthOptions += `<option value="${index}"${index === month ? ' selected' : ''}>${name}</option>`;
      });
      let yearOptions = '';
      for (let optionYear = yearStart; optionYear <= yearEnd; optionYear += 1) {
        yearOptions += `<option value="${optionYear}"${optionYear === year ? ' selected' : ''}>${optionYear}</option>`;
      }
      let html = `<div class="confidis-events__cal-nav">
        <button type="button" data-confidis-cal-prev aria-label="Previous month">‹</button>
        <select data-confidis-cal-month aria-label="Month">${monthOptions}</select>
        <select data-confidis-cal-year aria-label="Year">${yearOptions}</select>
        <button type="button" data-confidis-cal-next aria-label="Next month">›</button>
        <button type="button" data-confidis-cal-today>Today</button>
      </div><table><thead><tr>`;
      weekday.forEach((day, index) => {
        html += `<th><span class="confidis-events__cal-dow-full">${day}</span><span class="confidis-events__cal-dow-short">${weekdayShort[index]}</span></th>`;
      });
      html += '</tr></thead><tbody><tr>';
      for (let i = 0; i < startPad; i += 1) html += '<td></td>';
      for (let day = 1; day <= daysInMonth; day += 1) {
        if ((startPad + day - 1) % 7 === 0 && day !== 1) html += '</tr><tr>';
        const iso = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const matches = events.filter((event) => event.date === iso);
        const selected = iso === selectedDay ? ' data-selected="true"' : '';
        const todayAttr = iso === todayIso ? ' data-today="true"' : '';
        const eventWord = matches.length === 1 ? 'event' : 'events';
        const dayLabel = matches.length
          ? `${monthNames[month]} ${day}, ${matches.length} ${eventWord}`
          : `${monthNames[month]} ${day}`;
        let dots = '';
        matches.slice(0, 3).forEach(() => {
          dots += '<span class="confidis-events__cal-dot"></span>';
        });
        let titles = '';
        matches.forEach((event) => {
          titles += `<button type="button" data-confidis-open-event data-handle="${escapeHtml(
            event.handle,
          )}">${escapeHtml(event.title)}</button>`;
        });
        html += `<td${todayAttr}${selected} data-confidis-cal-day="${iso}">
          <button type="button" class="confidis-events__cal-select" aria-label="${escapeHtml(
            dayLabel,
          )}" aria-pressed="${iso === selectedDay ? 'true' : 'false'}">
            <span class="confidis-events__cal-num">${day}</span>
            <span class="confidis-events__cal-dots">${dots}</span>
          </button>
          <div class="confidis-events__cal-titles">${titles}</div>
        </td>`;
      }
      html += '</tr></tbody></table>';
      const dayEvents = events.filter((event) => event.date === selectedDay);
      const label = selectedDay
        ? new Date(`${selectedDay}T12:00:00`).toLocaleDateString(undefined, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          })
        : '';
      html += `<div class="confidis-events__agenda"><h2>${escapeHtml(label)}</h2>`;
      if (!dayEvents.length) {
        html += '<p class="confidis-events__agenda-empty">No events on this day.</p>';
      }
      dayEvents.forEach((event) => {
        const time = eventTimeLabel(event);
        html += `<button type="button" class="confidis-events__agenda-item" data-confidis-open-event data-handle="${escapeHtml(
          event.handle,
        )}">`;
        if (time) html += `<span class="confidis-events__agenda-time">${escapeHtml(time)}</span>`;
        html += `<span class="confidis-events__agenda-title">${escapeHtml(event.title)}</span></button>`;
      });
      html += '</div>';
      calendar.innerHTML = html;
    };

    calendar?.addEventListener('click', (event) => {
      const open = event.target.closest('[data-confidis-open-event]');
      if (open) {
        openLightbox(open.getAttribute('data-handle') || '');
        return;
      }
      const dayCell = event.target.closest('[data-confidis-cal-day]');
      if (dayCell && isCompactCalendar()) {
        selectedDay = dayCell.getAttribute('data-confidis-cal-day') || '';
        renderCalendar();
        return;
      }
      if (event.target.closest('[data-confidis-cal-prev]')) {
        view.setMonth(view.getMonth() - 1);
        selectedDay = defaultSelectedDay();
        renderCalendar();
      } else if (event.target.closest('[data-confidis-cal-next]')) {
        view.setMonth(view.getMonth() + 1);
        selectedDay = defaultSelectedDay();
        renderCalendar();
      } else if (event.target.closest('[data-confidis-cal-today]')) {
        view.setFullYear(today.getFullYear(), today.getMonth(), 1);
        selectedDay = defaultSelectedDay();
        renderCalendar();
      }
    });
    calendar?.addEventListener('change', (event) => {
      const monthSelect = event.target.closest('[data-confidis-cal-month]');
      const yearSelect = event.target.closest('[data-confidis-cal-year]');
      if (monthSelect) view.setMonth(Number(monthSelect.value));
      if (yearSelect) view.setFullYear(Number(yearSelect.value));
      if (monthSelect || yearSelect) {
        selectedDay = defaultSelectedDay();
        renderCalendar();
      }
    });
    if (calendar && typeof ResizeObserver === 'function') {
      new ResizeObserver(() => {
        if (calendar.hidden) return;
        const layout = isCompactCalendar() ? 'compact' : 'wide';
        if (layout !== appliedLayout) renderCalendar();
      }).observe(calendar);
    }

    const setView = (viewName) => {
      viewButtons.forEach((item) =>
        item.setAttribute('aria-pressed', String(item.getAttribute('data-confidis-view') === viewName)),
      );
      if (list) {
        list.setAttribute('data-view', viewName);
        list.hidden = viewName !== 'list';
      }
      if (grid) grid.hidden = viewName !== 'grid';
      if (calendar) {
        calendar.hidden = viewName !== 'calendar';
        if (viewName === 'calendar') requestAnimationFrame(() => renderCalendar());
      }
    };

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setView(button.getAttribute('data-confidis-view'));
      });
    });
  }

  const eventDialog = document.querySelector('[data-confidis-event-dialog]');
  const eventForm = document.querySelector('[data-confidis-event-form]');
  if (eventDialog && eventForm) {
    const dialogTitle = eventDialog.querySelector('[data-confidis-event-dialog-title]');
    const fields = eventForm.querySelector('[data-confidis-event-fields]');
    const handleInput = eventForm.querySelector('[data-confidis-event-handle]');
    const titleInput = eventForm.querySelector('#confidis-event-title');
    const dateInput = eventForm.querySelector('#confidis-event-date');
    const endInput = eventForm.querySelector('#confidis-event-end');
    const descriptionInput = eventForm.querySelector('#confidis-event-description');
    const zoomInput = eventForm.querySelector('#confidis-event-zoom');
    const activeInput = eventForm.querySelector('input[name="active"]');
    const status = eventForm.querySelector('[data-confidis-event-status]');
    const cancel = eventForm.querySelector('[data-confidis-event-cancel]');
    const close = eventDialog.querySelector('[data-confidis-event-close]');
    const remove = eventForm.querySelector('[data-confidis-event-delete]');
    const submit = eventForm.querySelector('[data-confidis-event-save]');
    const saveLabel = eventForm.querySelector('[data-confidis-event-save-label]');
    const saveSpinner = submit?.querySelector('.confidis-events__spinner');
    const busy = eventDialog.querySelector('[data-confidis-event-busy]');
    const busyText = eventDialog.querySelector('[data-confidis-event-busy-text]');
    const customerId = eventForm.querySelector('input[name="customer_id"]')?.value || '';

    const setBusy = (message) => {
      eventDialog.setAttribute('aria-busy', 'true');
      if (busy) busy.hidden = false;
      if (busyText) busyText.textContent = message;
      if (fields) fields.disabled = true;
      if (submit) submit.disabled = true;
      if (cancel) cancel.disabled = true;
      if (remove) remove.disabled = true;
    };

    const clearBusy = () => {
      eventDialog.removeAttribute('aria-busy');
      if (busy) busy.hidden = true;
      if (fields) fields.disabled = false;
      if (submit) submit.disabled = false;
      if (cancel) cancel.disabled = false;
      if (remove) remove.disabled = false;
      if (saveLabel) saveLabel.textContent = 'Save';
      if (saveSpinner) saveSpinner.hidden = true;
    };

    const resetForm = () => {
      eventForm.reset();
      if (handleInput) handleInput.value = '';
      if (activeInput) activeInput.checked = true;
      if (status) status.textContent = '';
      if (remove) remove.hidden = true;
    };

    const openCreate = () => {
      resetForm();
      clearBusy();
      if (dialogTitle) dialogTitle.textContent = 'Add event';
      eventDialog.showModal();
    };

    const openEdit = async (handle) => {
      resetForm();
      if (dialogTitle) dialogTitle.textContent = 'Edit event';
      if (handleInput) handleInput.value = handle;
      if (remove) remove.hidden = false;
      eventDialog.showModal();
      setBusy('Loading event…');
      try {
        const params = new URLSearchParams({ handle, customer_id: customerId });
        const response = await fetch(`${eventForm.action}?${params}`, {
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        if (!data.ok || !data.event) {
          clearBusy();
          if (status) status.textContent = data.error || 'Could not load this event.';
          return;
        }
        if (titleInput) titleInput.value = data.event.title || '';
        if (dateInput) dateInput.value = toLocalInput(data.event.date);
        if (endInput) endInput.value = toLocalInput(data.event.end);
        if (descriptionInput) descriptionInput.value = data.event.description || '';
        if (zoomInput) zoomInput.value = data.event.zoom_link || '';
        if (activeInput) activeInput.checked = data.event.status === 'ACTIVE';
        clearBusy();
      } catch (error) {
        clearBusy();
        if (status) status.textContent = 'Could not load this event.';
      }
    };

    document.querySelectorAll('[data-confidis-add-event]').forEach((button) => {
      button.addEventListener('click', openCreate);
    });
    document.querySelectorAll('[data-confidis-edit-event]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        openEdit(button.getAttribute('data-handle') || '');
      });
    });
    cancel?.addEventListener('click', () => {
      if (cancel.disabled) return;
      eventDialog.close();
    });
    close?.addEventListener('click', () => {
      eventDialog.close();
    });
    remove?.addEventListener('click', async () => {
      if (remove.disabled || remove.hidden) return;
      const handle = handleInput?.value || '';
      if (!handle) return;
      if (!window.confirm('Delete this event? This cannot be undone.')) return;
      if (status) status.textContent = '';
      setBusy('Deleting…');
      try {
        const response = await fetch(eventForm.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'delete',
            customer_id: customerId,
            event_handle: handle,
          }),
        });
        const data = await response.json();
        if (!data.ok) {
          clearBusy();
          if (status) status.textContent = data.error || 'Could not delete this event.';
          return;
        }
        if (busyText) busyText.textContent = 'Deleted. Refreshing…';
        window.location.assign('/pages/events');
      } catch (error) {
        clearBusy();
        if (status) status.textContent = 'Could not delete. Try again in a moment.';
      }
    });

    eventForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit?.disabled) return;
      if (status) status.textContent = '';
      const payload = Object.fromEntries(new FormData(eventForm).entries());
      payload.active = activeInput?.checked ? 'true' : 'false';
      setBusy('Saving…');
      if (saveLabel) saveLabel.textContent = 'Saving…';
      if (saveSpinner) saveSpinner.hidden = false;
      try {
        const response = await fetch(eventForm.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!data.ok) {
          clearBusy();
          if (status) status.textContent = data.error || 'Something went wrong.';
          return;
        }
        if (busyText) busyText.textContent = 'Saved. Refreshing…';
        window.location.reload();
      } catch (error) {
        clearBusy();
        if (status) status.textContent = 'Could not save. Try again in a moment.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confidis-membership"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-confidis-terms]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const dialog = document.getElementById('confidis-terms-dialog');
      if (typeof dialog?.showDialog === 'function') {
        dialog.showDialog();
        return;
      }
      window.location.assign(link.href);
    });
  });

  const teamForm = document.querySelector('[data-confidis-team-form]');
  const roster = document.querySelector('[data-team-roster]');

  function teamFormPayload(form) {
    const members = [...form.querySelectorAll('[data-team-row]')].map((row) => ({
      full_name: row.querySelector('[name="full_name"]')?.value.trim() || '',
      email: row.querySelector('[name="email"]')?.value.trim() || '',
      phone: row.querySelector('[name="phone"]')?.value.trim() || '',
      discipline: row.querySelector('[name="discipline"]')?.value.trim() || '',
    }));
    return {
      customer_id: form.querySelector('[name="customer_id"]')?.value,
      members,
    };
  }

  function resetTeamForm(form) {
    const tbody = form.querySelector('[data-team-rows]');
    const template = form.querySelector('[data-team-row-template]');
    if (!tbody || !template) {
      form.reset();
      return;
    }
    tbody.replaceChildren();
    tbody.appendChild(template.content.cloneNode(true));
  }

  function formatInvited(value) {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  function cloneTeamIcon(selector) {
    const svg = roster?.querySelector(selector)?.content.querySelector('svg');
    if (!svg) return null;
    const copy = svg.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.setAttribute('focusable', 'false');
    return copy;
  }

  function rosterActionButton(label, datasetName, memberId, iconSelector) {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset[datasetName] = memberId;
    const icon = cloneTeamIcon(iconSelector);
    if (icon) button.append(icon);
    button.append(document.createTextNode(label));
    return button;
  }

  function setRosterStatus(message, kind) {
    const status = roster?.querySelector('[data-team-roster-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.removeAttribute('data-kind');
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.dataset.kind = kind || 'success';
  }

  async function postTeamAction(path, memberId) {
    const origin = roster?.dataset.confidisApi;
    const buyerId = roster?.dataset.confidisBuyerId;
    if (!origin || !buyerId) {
      return { ok: false, error: 'Team setup is missing API settings.' };
    }
    const response = await fetch(`${origin}${path}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customer_id: buyerId,
        member_id: memberId,
      }),
    });
    return response.json();
  }

  async function loadRoster() {
    if (!roster) return;
    const origin = roster.dataset.confidisApi;
    const buyerId = roster.dataset.confidisBuyerId;
    const loading = roster.querySelector('[data-team-roster-loading]');
    const refresh = roster.querySelector('[data-team-roster-refresh]');
    const empty = roster.querySelector('[data-team-roster-empty]');
    const table = roster.querySelector('[data-team-roster-table]');
    const body = roster.querySelector('[data-team-roster-body]');
    if (!origin || !buyerId || !empty || !table || !body) return;

    if (loading) loading.hidden = false;
    if (refresh) refresh.disabled = true;
    empty.hidden = true;
    table.hidden = true;

    try {
      const response = await fetch(
        `${origin}/team?customer_id=${encodeURIComponent(buyerId)}`,
        { headers: { Accept: 'application/json' } },
      );
      const data = await response.json();
      if (!data.ok) {
        empty.hidden = false;
        table.hidden = true;
        empty.textContent = data.error || 'Could not load your team.';
        return;
      }

      const members = Array.isArray(data.members) ? data.members : [];
      body.replaceChildren();
      if (!members.length) {
        empty.hidden = false;
        empty.textContent = 'No team members yet.';
        table.hidden = true;
        return;
      }

      empty.hidden = true;
      table.hidden = false;
      members.forEach((member) => {
        const row = document.createElement('tr');
        const emailCell = document.createElement('td');
        emailCell.textContent = member.email || '—';
        const nameCell = document.createElement('td');
        nameCell.textContent = member.name || '—';
        const statusCell = document.createElement('td');
        statusCell.textContent = member.status || 'Invited';
        const invitedCell = document.createElement('td');
        invitedCell.textContent = formatInvited(member.invited_at);
        const actionsCell = document.createElement('td');
        const actions = document.createElement('div');
        actions.className = 'confidis-roster__actions';
        actions.append(
          rosterActionButton('Resend', 'resendMember', member.customer_id, '[data-team-icon-resend]'),
          rosterActionButton('Remove', 'removeMember', member.customer_id, '[data-team-icon-remove]'),
        );
        actionsCell.append(actions);
        row.append(emailCell, nameCell, statusCell, invitedCell, actionsCell);
        body.append(row);
      });
    } catch (error) {
      empty.hidden = false;
      table.hidden = true;
      empty.textContent = 'Could not load your team.';
    } finally {
      if (loading) loading.hidden = true;
      if (refresh) refresh.disabled = false;
    }
  }

  if (teamForm) {
    const tbody = teamForm.querySelector('[data-team-rows]');
    const template = teamForm.querySelector('[data-team-row-template]');
    teamForm.querySelector('[data-add-row]')?.addEventListener('click', () => {
      if (!tbody || !template) return;
      tbody.appendChild(template.content.cloneNode(true));
    });
    tbody?.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-remove-row]');
      if (!remove) return;
      const rows = tbody.querySelectorAll('[data-team-row]');
      if (rows.length <= 1) return;
      remove.closest('[data-team-row]')?.remove();
    });
  }

  roster?.addEventListener('click', async (event) => {
    const refresh = event.target.closest('[data-team-roster-refresh]');
    if (refresh) {
      await loadRoster();
      return;
    }
    const resend = event.target.closest('[data-resend-member]');
    const remove = event.target.closest('[data-remove-member]');
    const button = resend || remove;
    if (!button) return;
    const memberId = resend?.dataset.resendMember || remove?.dataset.removeMember;
    if (!memberId) return;
    if (remove && !window.confirm('Remove this team member? They will lose member access.')) {
      return;
    }
    button.disabled = true;
    setRosterStatus(resend ? 'Resending…' : 'Removing…', 'pending');
    try {
      const data = await postTeamAction(
        resend ? '/team/resend' : '/team/remove',
        memberId,
      );
      setRosterStatus(
        data.ok ? data.message || 'Done.' : data.error || 'Something went wrong.',
        data.ok ? 'success' : 'error',
      );
      if (data.ok) await loadRoster();
    } catch (error) {
      setRosterStatus('Could not update the team. Try again in a moment.', 'error');
    } finally {
      button.disabled = false;
    }
  });

  if (roster) loadRoster();

  document.querySelectorAll('[data-confidis-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const panel = form.closest('.confidis-membership__panel') || form.parentElement;
      const status = panel?.querySelector('[data-confidis-status]');
      const isTeamForm = form.hasAttribute('data-confidis-team-form');
      const button = form.querySelector('button[type="submit"]');
      if (isTeamForm) {
        setRosterStatus('Submitting…', 'pending');
      } else if (status) {
        status.textContent = 'Submitting…';
      }
      if (button) button.disabled = true;
      try {
        const payload = isTeamForm
          ? teamFormPayload(form)
          : Object.fromEntries(new FormData(form).entries());
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        const message = data.ok
          ? data.message || 'Done.'
          : data.error || 'Something went wrong.';
        if (isTeamForm) {
          setRosterStatus(message, data.ok ? 'success' : 'error');
        } else if (status) {
          status.textContent = message;
        }
        if (data.ok && isTeamForm) {
          resetTeamForm(form);
        } else if (data.ok && form.hasAttribute('data-confidis-redirect')) {
          window.location.assign(form.getAttribute('data-confidis-redirect'));
        } else if (data.ok) {
          form.hidden = true;
        }
      } catch (error) {
        if (isTeamForm) {
          setRosterStatus('Could not submit. Try again in a moment.', 'error');
        } else if (status) {
          status.textContent = 'Could not submit. Try again in a moment.';
        }
      } finally {
        if (button) button.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
